import * as CONSTANTS from '../../constants';

export default {

    /**
     * Sets the dismiss value for the specific instruction on given page.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.INSTRUCTION_DISMISS] (state, payload) {
        // If there is any dismiss status then update
        if (payload.dismiss) {
            state[payload.page].dismiss = payload.dismiss;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/instruction/mutations.js